import { capitalize, chain } from 'lodash';
import isUrl from 'is-url-superb';
import React, { useMemo, useState } from 'react';
import { assert } from '../../../../util/assert';
import {
    AnyMappableEntity,
    Asset,
    getDefinitionStatus,
    Integration,
    IntegrationDefinition,
    IntegrationDefinitionStatus,
    MappingConnection,
} from '../../../../domain/assets';
import {
    getInvariantErrors,
    OrganizationMappingAggregate,
} from '../../../../service/assets';
import { ApiError } from '../../../../base';
import { AssetNewConfig } from './assetNewConfig';
import { AssetNewController } from './assetNewInterface';
import { AssetNewViewProps } from './assetNewProps';

export function createAssetNewController(config: AssetNewConfig): AssetNewController {
    return {
        useProps(context, data, form, props): AssetNewViewProps {
            const [asset, ...rest] = data.find.data ?? [];
            return {
                getFormProps() {
                    return {
                        isSubmittable: form.formState.isDirty || !!asset,
                        error: data.create.error ?? data.update.error,
                        async onSubmit(values) {
                            if (asset) {
                                const response = await data.update.mutateAsync([
                                    asset.id,
                                    values,
                                ]);
                                return response;
                            }
                            const response = await data.create.mutateAsync({
                                ...values,
                                type: 'website',
                                isVisible: true,
                            });
                            return response;
                        },
                    };
                },
                getControlProps(key) {
                    const error = form.formState.errors[key] ?? null;
                    return {
                        isInvalid: !!error,
                        error,
                    };
                },
                getInputProps(key) {
                    return { ...form.register(key) };
                },
                // getTypeOptionProps(key) {
                //     return {
                //         options: [
                //             {
                //                 value: 'ecommerce_website',
                //                 label: 'Ecommerce website',
                //             },
                //             {
                //                 value: 'saas',
                //                 label: 'Saas',
                //             },
                //             {
                //                 value: 'marketplace',
                //                 label: 'Marketplace',
                //             },
                //             {
                //                 value: 'mobile_app',
                //                 label: 'Mobile app',
                //             },
                //             {
                //                 value: 'website',
                //                 label: 'Website',
                //             },
                //         ],
                //     };
                // },
            };
        },
    };
}
